export const fetchWrapper = {
  get,
  post,
  put,
  delete: _delete
};

const headers = new Headers({
  "Accept": "application/json",
  "Content-Type": "application/json",
  "User-Agent": "US-VENDORLAND"
});

function get(url) {
  const requestOptions = {
    method: 'GET',
    headers: headers
  };
  return fetch(url, requestOptions).then(handleResponse);
}

function post(url, body) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  };
  return fetch(url, requestOptions).then(handleResponse);
}

function put(url, body) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  };
  return fetch(url, requestOptions).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url) {
  const requestOptions = {
    method: 'DELETE'
  };
  return fetch(url, requestOptions).then(handleResponse);
}

// helper functions

function handleResponse(response) {
  return response
    .text()
    .then(text => {
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (err) {
        // If response text is not valid JSON, we leave data as null
      }

      if (!response.ok) {
        const error = (data && JSON.stringify(data.AdditionalData)) || response.statusText;
        console.error(error);
        return Promise.reject(error);
      }

      return data;
    });
}